
import { defineComponent, PropType } from 'vue'
import type { Marker } from '~/components/zeal/ZChart/constants'

export default defineComponent({
  name: 'UsageMetricChart',
  props: {
    title: { type: String, required: true },
    total: { type: String, required: true },
    totalLabel: { type: String, default: 'Total' },
    dataSet: {
      type: Array as PropType<Array<{ name: string; values: number[] }>>,
      required: true
    },
    labels: { type: Array as PropType<string[]>, required: true },
    yMarkers: { type: Array as PropType<Marker[] | null>, default: null },
    colors: { type: Array as PropType<string[]>, default: () => ['juniper-500'] },
    tooltipOptions: { type: Object, default: null },
    height: { type: Number, default: 250 }
  },
  computed: {
    chartAxisOptions() {
      return {
        yGridLine: false,
        yTickLabels: false,
        xTickValues: this.labels.length ? [0, this.labels.length - 1] : [],
        margin: { top: 20, bottom: 20 },
        padding: { left: 0, right: 0 }
      }
    }
  }
})
